import { Component } from '@angular/core';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { BaseComponent } from '../../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../../services/account.service';

@Component({
    selector: 'profile-image',
    templateUrl: './profile-image.component.html',
})
export class ProfileImageComponent extends BaseComponent {

    imageChangedEvent: any = '';
    croppedImage: any = '';

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private accService: AccountService, ) {
        super(route);
    }

    fileChangeEvent(event: any): void {
        this.imageChangedEvent = event;
    }
    imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64;
    }
    imageLoaded() {
        // show cropper
    }
    cropperReady() {
        // cropper ready
    }
    loadImageFailed() {
        // show message
    }

    cancel() {

    }

    save() {
        this.emitDisplayLoadingDialog(true);
        this.accService.setProfileImage(this.croppedImage)
            .subscribe(
                r => this.router.navigateByUrl('/'),
                e => {
                    var a = e;
                    this.showDialog("Changes not saved, please try again", true);
                },
                () => this.emitDisplayLoadingDialog(false)
            );
    }

}
